import i18n from 'i18next';
import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({}) => {
  return {
    fetchDashboardData: {
      [SERVICE_PROVIDERS.EDVIR]: () => true,
      default: () => false,
    },
    topAction_bulkDownloadReport: {
      [SERVICE_PROVIDERS.SPIREON]: () => true,
      default: () => false,
    },
    components_itemsPerPage: {
      [SERVICE_PROVIDERS.SPIREON]: () => 10,
      default: () => 15,
    },
    config_displayLength: {
      [SERVICE_PROVIDERS.SPIREON]: () => 10,
      default: () => 15,
    },

    renderComp_driverId: {
      [SERVICE_PROVIDERS.SPIREON]: () => 'Select User',
      default: () => i18n.t('common.pleaseSelect'),
    },

    renderComp_vehicleId: {
      [SERVICE_PROVIDERS.SPIREON]: () => 'Select Asset',
      default: () => i18n.t('common.pleaseSelect'),
    },

    renderComp_mechanicId: {
      [SERVICE_PROVIDERS.SPIREON]: () => 'Select User',
      default: () => i18n.t('common.pleaseSelect'),
    },

    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
